<template>
  <QsDrawer
    v-if="visible"
    :title="row.isEdit ? '编辑账户' : '新增账户'"
    :visible.sync="visible"
    @close="cancelHandle"
    cusSize="md"
    :destory-on-close="true"
    :append-to-body="true"
    :destroy-on-close="true"
    :modal-append-to-body="false"
  >
    <form-text-box
      ref="partnerAccountBox"
      :column="1"
      :dataList="accountList"
      :rules="accountRules"
      :formProps="formProps"
      :model="model"
    >
    </form-text-box>
    <template slot="footer">
      <div class="footer">
        <el-button size="small" @click="cancelHandle">取消</el-button>
        <el-button
          :loading="loading"
          size="small"
          type="primary"
          @click="submit"
          >{{ row.isEdit ? '保存' : '开户' }}</el-button
        >
      </div>
    </template>
  </QsDrawer>
</template>

<script>
import {
  getSubAccountDetail,
  getWithholdingBankType,
  saveSubAccount,
} from '@/api/domain/finance'
import { filter, merge, pick } from 'lodash'
import config from '../config'

export default {
  name: 'addChildAccount',
  model: {
    prop: 'show',
    event: 'change',
  },
  watch: {
    channelType(val) {
      this.model.channelType = val
    },
  },
  data() {
    const { accountList, accountRules } = config.call(this)
    return {
      visible: false,
      loading: false,
      accountList,
      row: {},
      accountRules,
      formProps: {
        labelWidth: '190px',
      },
      model: {
        channelType: '',
        merchantName: '',
        licenceNo: '',
        legalContactName: '',
        legalContactMobile: '',
        legalIdType: '',
        legalIdNo: '',
      },
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    open(rowData) {
      if (!rowData) {
        this.row = {}
      } else {
        this.row = rowData
      }
      this.model.channelType = rowData.channelType
      this.visible = true
      this.getChannelTabList()
      if (this.row.isEdit) {
        this.model.accountId = rowData.accountId
        if (
          this.accountList.findIndex(
            (item) => item.itemConfig.prop === 'accountId',
          ) === -1
        ) {
          this.accountList.splice(0, 0, {
            el: 'input',
            itemConfig: {
              label: '子户ID',
              prop: 'accountId',
            },
            elConfig: {
              placeholder: '请输入',
              maxlength: '100',
              disabled: true,
            },
          })
        }

        this.getSubAccountModel()
        this.$nextTick(() => {
          this.$refs.partnerAccountBox.setItemData({
            elConfigKey: 'disabled',
            key: 'accountId',
            data: true,
          })
          this.$refs.partnerAccountBox.setItemData({
            elConfigKey: 'disabled',
            key: 'merchantName',
            data: true,
          })
          this.$refs.partnerAccountBox.setItemData({
            elConfigKey: 'disabled',
            key: 'licenceNo',
            data: true,
          })
        })
      } else {
        this.$nextTick(() => {
          this.$refs.partnerAccountBox.setItemData({
            elConfigKey: 'disabled',
            key: 'merchantName',
            data: false,
          })
          this.$refs.partnerAccountBox.setItemData({
            elConfigKey: 'disabled',
            key: 'licenceNo',
            data: false,
          })
        })
      }
    },
    cancelHandle() {
      this.$refs.partnerAccountBox?.getRefs().resetFields()
      this.model = {
        channelType: '',
        merchantName: '',
        licenceNo: '',
        legalContactName: '',
        legalContactMobile: '',
        legalIdType: '',
        legalIdNo: '',
      }
      if (this.row.isEdit) {
        this.accountList.splice(0, 1)
      }
      this.row = {}
      this.$emit('change', this.visible)
      this.visible = false
    },
    submit() {
      this.$refs.partnerAccountBox.getRefs().validate(async (validate) => {
        if (validate) {
          const params = [
            'accountId',
            'channelType',
            'merchantName',
            'licenceNo',
            'legalContactName',
            'legalContactMobile',
            'legalIdType',
            'legalIdNo',
            'contactName',
            'contactMobile',
            'fullAddress',
          ]
          const req = this.row.isEdit
            ? pick(this.model, params)
            : pick(
              this.model,
              filter(params, (item) => item !== 'accountId'),
            )
          this.loading = true
          const { code, data } = await saveSubAccount({
            ...req,
            accountType: 2,
          })
          if (code === 1) {
            if (data.result) {
              this.$message.success(`${this.row.isEdit ? '编辑' : '新增'}成功`)
              this.cancelHandle()
              this.$emit('submitSucc')
            } else {
              this.$message.error(data.info)
            }
          }
          this.loading = false
        }
      })
    },
    async getChannelTabList() {
      const { code, data } = await getWithholdingBankType({ accountType: 2 })
      if (code === 1) {
        this.$refs.partnerAccountBox.setItemData({
          elConfigKey: 'list',
          key: 'channelType',
          data,
        })
      }
    },
    async getSubAccountModel() {
      const { code, data, msg } = await getSubAccountDetail({
        accountId: this.row.accountId,
        type: 3,
      })
      if (code === 1) {
        this.model = merge(this.model, data)
      } else {
        this.$message.error(msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;
}
::v-deep .el-form-item{
  width: 100% !important;
  > .el-form-item__content{
    flex: 1 !important;
    padding-right: 20px!important;
    > .el-select {
      width: 100%!important;
    }
  }
}
</style>
